import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import Link from 'components/Link'
import defaultAuthorImg from 'assets/img/mcc_defaultAuthor.png'
import { parseLocalDate } from 'utils/helpers'

import {
   StyledWrapper,
   StyledCategories,
   StyledTitle,
   StyledAuthors,
   StyledAuthorImg,
   StyledAuthorName,
   StyledInfo,
   StyledDate,
} from './styles'

export default function PostHeader({ title, timeRead, date, categories, authors, authorLabel, langPrefix, lang, disableTextBalance }) {
   return (
      <>
         <StyledWrapper>
            {Array.isArray(categories) && (
               <StyledCategories>
                  {categories.map((category) => (
                     <li key={category.categoryName}>
                        <Link url={`${langPrefix}category/${category.categoryName}/`} type="internal">
                           {category.categoryName}
                        </Link>
                     </li>
                  ))}
               </StyledCategories>
            )}
            <StyledTitle $disableTextBalance={disableTextBalance}>{title}</StyledTitle>
            <StyledInfo>
               {Array.isArray(authors) ? (
                  <StyledAuthors>
                     <div>
                        {authors.map((author, index) => (
                           <StyledAuthorImg key={author.id} n={index}>
                              {author.profilePhoto?.gatsbyImage && (
                                 <GatsbyImage image={author.profilePhoto.gatsbyImage} alt={author.name} />
                              )}
                           </StyledAuthorImg>
                        ))}
                     </div>
                     <StyledAuthorName>
                        <span>{authorLabel} </span>
                        {authors.map((author, index) => {
                           if (index > 0) {
                              return (
                                 <React.Fragment key={author.id}>
                                    <span> & </span>
                                    {author.socialUrl ? (
                                       <a href={author.socialUrl} target="_blank" rel="noreferrer">
                                          {author.name}
                                       </a>
                                    ) : (
                                       author.name
                                    )}
                                 </React.Fragment>
                              )
                           }
                           return (
                              <React.Fragment key={author.id}>
                                 {author.socialUrl ? (
                                    <a href={author.socialUrl} target="_blank" rel="noreferrer">
                                       {author.name}
                                    </a>
                                 ) : (
                                    author.name
                                 )}
                              </React.Fragment>
                           )
                        })}
                     </StyledAuthorName>
                  </StyledAuthors>
               ) : (
                  <StyledAuthors>
                     <div>
                        <StyledAuthorImg>
                           <img src={defaultAuthorImg} alt="Multicoin capital" />
                        </StyledAuthorImg>
                     </div>
                     <StyledAuthorName>
                        <span>{authorLabel} </span>
                        <strong>Multicoin Capital</strong>
                     </StyledAuthorName>
                  </StyledAuthors>
               )}
               <StyledDate>
                  {parseLocalDate(date, lang)} | {timeRead}
               </StyledDate>
            </StyledInfo>
         </StyledWrapper>
      </>
   )
}
